import "./StandardLayout.scss";
import { Outlet } from "react-router-dom";
import { StandardHeader, AppFooter } from "../../components";

export default function StandardLayout() {
  return (
    <div className="standardLayout-cont">
      <StandardHeader />
      <Outlet />
      <AppFooter />
    </div>
  );
}
